export function calculateReviewStatus(task) {
  const decisionFields = [
    task.project_id,
    task.status_id,
    task.context_id,
    task.focus_area_id,
    task.task_time_id,
    task.priority_id,
    task.location_id,
    task.time_of_day_id,
    task.impact_id,
    task.capacity_id,
    task.day_type_id,
    task.due_date,
    task.start_date
  ];

  const filledCount = decisionFields.filter(
    field => field !== null && field !== undefined && field !== ''
  ).length;

  return filledCount >= 3 ? 3 : 1;
}

export function ReviewStatusBadge({ reviewStatus }) {
  const labels = {
    1: 'Fresh',
    2: 'Needs Review',
    3: 'Converted',
    4: 'Missed',
    5: 'Deferred',
    6: 'Discarded',
    7: 'Complete'
  }

  if (!reviewStatus) return null

  return (
    <span
      style={{
        marginLeft: '8px',
        padding: '2px 8px',
        borderRadius: '12px',
        fontSize: '12px',
        background: '#f3f4f6',
        color: '#444'
      }}
    >
      {labels[reviewStatus]}
    </span>
  )
}